import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import PriceBadge from "./PriceBadge";

export default function CityCard({ city, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8% 0px" }}
      transition={{ duration: 0.85, delay: (index % 4) * 0.06, ease: [0.22, 1, 0.36, 1] }}
      className="group"
    >
      <Link to={`/cities/${city.slug}`} data-testid={`city-card-${city.slug}`}>
        <div className="relative overflow-hidden aspect-[3/4] card-flat">
          <img
            src={city.image}
            alt={`${city.name} — car rentals`}
            className="w-full h-full object-cover group-hover:scale-[1.06] transition-transform duration-[1100ms] ease-[cubic-bezier(0.22,1,0.36,1)]"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B2545] via-[#0B2545]/40 to-transparent" />
          <div className="absolute top-4 left-4">
            <span className="overline-light">
              {String(index + 1).padStart(2, "0")} · US
            </span>
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 flex items-end justify-between gap-3">
            <div>
              <h3 className="font-serif text-3xl md:text-4xl text-white leading-tight">
                {city.name}
              </h3>
              <p className="mt-1.5 text-[11px] text-white/70 font-mono tracking-widest uppercase">
                {city.airports.join(" · ")}
              </p>
            </div>
            <PriceBadge price={city.startingFrom} size="sm" tone="dark" />
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
